import {User} from "../../models/user";
import {Link} from "@tanstack/react-router";
import React from "react";
import {ROUTES} from "../../constants";

export function ProfileLink({user}: {user: User}) {
    return <Link to={ROUTES.USER_PUBLIC_PROFILE} params={{username: user.name}}>{user.name}</Link>
}
